import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Import Common Utilss
import { Loader, ErrorComponent } from 'shared-components';
import { DEFAULT_SERVICE_CONFIGURATION } from 'shared-components/src/utils/services';

// Import Shared utils
import { get } from 'shared-components/src/utils/http';

const ServiceConfigContext = React.createContext();

const ServiceConfigProvider = ({ children }) => {
  const [configs, setConfigs] = useState(DEFAULT_SERVICE_CONFIGURATION);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const configData = await get(
          '/api/v1/cardholder_portal/service_configuration'
        );

        setConfigs(configData.data);
      } catch (e) {
        setError(true);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const renderBody = () => {
    if (loading) return <Loader />;
    if (error) return <ErrorComponent />;

    return <>{children}</>;
  };

  return (
    <ServiceConfigContext.Provider value={configs}>
      {renderBody()}
    </ServiceConfigContext.Provider>
  );
};

ServiceConfigProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { ServiceConfigContext, ServiceConfigProvider };
